import axios from "axios";
// import { notifyFailure, notifySuccess } from "../components/toast";

import {
  CATEGORIES_CREATE_REQUEST,
  CATEGORIES_CREATE_SUCCESS,
  CATEGORIES_CREATE_FAIL,
  ALL_CATEGORIES_VIEW_REQUEST,
  ALL_CATEGORIES_VIEW_SUCCESS,
  ALL_CATEGORIES_VIEW_FAIL,
  CATEGORY_UPDATE_REQUEST,
  CATEGORY_UPDATE_SUCCESS,
  CATEGORY_UPDATE_FAIL,
  SERVERADDRESS,
} from "../constants";
// import { notifyFailure, notifySuccess } from "../components/toast";

export const createCategories =
  (obj, callback, setReservationId) => async (dispatch) => {
    dispatch({
      type: CATEGORIES_CREATE_REQUEST,
    });
    try {
      const { data } = await axios.post(
        `${SERVERADDRESS}/v1/categories/createCategories`,
        obj
      );
      dispatch({
        type: CATEGORIES_CREATE_SUCCESS,
        payload: data,
      });
      callback && callback(data.id);
    } catch (err) {
      //   notifyFailure(err.response.data.message);
      dispatch({
        type: CATEGORIES_CREATE_FAIL,
        payload: err,
      });
    }
  };

export const getAllCategories = (obj, callback) => async (dispatch) => {
  dispatch({
    type: ALL_CATEGORIES_VIEW_REQUEST,
  });
  try {
    const { data } = await axios.get(
      `${SERVERADDRESS}/v1/categories/getAllCategories`,
      obj
    );

    localStorage.setItem("categories", JSON.stringify(data));
    console.log(data, "data");

    dispatch({
      type: ALL_CATEGORIES_VIEW_SUCCESS,
      payload: data,
    });
  } catch (err) {
    console.log(err);
    dispatch({
      type: ALL_CATEGORIES_VIEW_FAIL,
      payload: err,
    });
  }
};

export const updateCategoriesById =
  (obj, handleSuccess) => async (dispatch) => {
    dispatch({
      type: CATEGORY_UPDATE_REQUEST,
    });
    try {
      const { data } = await axios.patch(
        `${SERVERADDRESS}/v1/categories/updateCategoriesById`,
        obj
      );
      handleSuccess();
      // notifySuccess("Updated successfully !");
      dispatch({
        type: CATEGORY_UPDATE_SUCCESS,
        payload: data,
      });
    } catch (err) {
      // console.log(err);
      // notifyFailure(err?.response?.data?.message);
      dispatch({
        type: CATEGORY_UPDATE_FAIL,
        payload: err,
      });
    }
  };
